import { render, staticRenderFns } from "./VFatherProProfile.vue?vue&type=template&id=40a7cfb2"
import script from "./VFatherProProfile.vue?vue&type=script&lang=js"
export * from "./VFatherProProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports